"use client"

import PlaylistCardImageCanvas from "./PlaylistCardImageCanvas"

type Props = {
  title?: string
  imgUrl?: string
  loaded: boolean
  setLoaded: React.Dispatch<React.SetStateAction<boolean>>
  showPlay?: boolean
  isPlaying?: boolean
  canvasActive?: boolean
  duration?: string
}

export default function PlaylistCardImage({
  title,
  imgUrl,
  loaded,
  setLoaded,
  showPlay,
  isPlaying,
  canvasActive = false,
  duration = "",
}: Props) {
  return (
    <div className="relative h-full w-full">
      {/* IMAGEN NORMAL */}
      {imgUrl && (
        <img
          src={imgUrl}
          alt={title ?? ""}
          draggable={false}
          onLoad={() => setLoaded(true)}
          className={`
            absolute
            inset-0
            h-full
            w-full
            rounded-lg
            object-cover
            transition-opacity
            duration-300
            ${loaded ? "opacity-100" : "opacity-0"}
          `}
        />
      )}

      {/* CANVAS MIXTAPE */}
      <PlaylistCardImageCanvas
        src={imgUrl}
        active={canvasActive}
        title={title}
        duration={duration}
      />
    </div>
  )
}